<script lang="ts">
    import { getColor } from '$lib/helper';

    import CountdownView from './Countdown.View.svelte';

    import type { CountdownContent } from '$lib/types/Components/Countdown/CountdownContent';
    import type { Language } from '$lib/types/Language';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';

    export let id = '';
    export let theme: Theme;
    export let content: CountdownContent;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let language: Language = 'en';
</script>

<CountdownView
    {id}
    box={content.box}
    color={getColor(content.color, theme.fontColor)}
    showSeconds={content.showSeconds}
    showLabels={content.showLabels}
    cycle={content.cycle}
    {language}
    datetime={content.datetime}
    {transitionDelay}
    {transitionEffect}
/>
